import React, { useCallback, useState } from 'react'
import AsyncSelect from 'react-select/async'

import api from '../../../services/api'
import Alert from '../../../components/Alert'
import { ButtonAdd } from '../../../components/ButtonAdd'

export default function AdicionarUsuario({
  key_id,
  api_id,
  api_scope,
  api_public,
  afterCreate
}) {
  const [alert, setAlert] = useState()
  const [user, setUser] = useState('')

  const getUsers = useCallback(
    async search => {
      if (search.length > 0 && search.length < 3) return
      const r = await api.get(
        `/usuarios/${`?scope=${api_scope}&public=${api_public}&search=${search}`}`
      )
      return r.data.map(data => ({
        value: data._id,
        label: data.name + ' - ' + data.organization.name
      }))
    },
    [api_scope, api_public]
  )

  async function saveUsuario(e) {
    e.preventDefault()
    const button = e.target
    button.disabled = true
    const r = await api
      .post(`/chaves/${key_id}/usuarios`, { user })
      .then(data => data)
      .catch(error => error.response.data)
    if (r.error) {
      setAlert(<Alert color="danger">{r.error.message}</Alert>)
    } else {
      setAlert(<Alert color="success">Usuário adicionado!</Alert>)
      afterCreate()
    }
    button.disabled = false
  }

  return (
    <>
      {alert}
      <div className="mb-3">
        <div className="field is-horizontal">
          <div className="field-body">
            <div className="field">
              <div className="control">
                <div className="is-fullwidth has-text-dark">
                  <AsyncSelect
                    id="user-key"
                    name="user"
                    cacheOptions
                    defaultOptions
                    loadOptions={getUsers}
                    onChange={e => setUser(e.value)}
                    placeholder="Selecione..."
                  />
                </div>
              </div>
            </div>
            <ButtonAdd small={false} onClick={e => saveUsuario(e)}></ButtonAdd>
          </div>
        </div>
      </div>
    </>
  )
}
